import { Box, Center, Image, Text } from '@chakra-ui/react';
import { MenuModel } from 'lib/api/model';
import { useEffect, useState } from 'react';

interface ISubMenuItemProps {
  item: MenuModel;
  idxMenu: number[];
  onPress: (id: number) => void;
  onPressInfo: (
    id: number,
    title: string,
    image: string,
    ratio: number,
    description: string
  ) => void;
}

function SubMenuItem(props: ISubMenuItemProps) {
  const [selected, setSelected] = useState(false);
  useEffect(() => {
    setSelected(
      props.idxMenu.find((element) => element === props.item.id) !== undefined
    );
  }, [props.idxMenu]);

  return (
    <Box
      position={'relative'}
      w={'155px'}
      h="56px"
      border={selected ? '2px' : '1px'}
      borderRadius="md"
      bg={selected ? '#f9fefb' : 'white'}
      borderColor={selected ? '#5bbca6' : '#eeeeee'}
      boxShadow="base"
      cursor={'pointer'}
      overflow="hidden">
      <Center h={'full'} onClick={() => props.onPress(props.item.id)}>
        <Text fontSize={'14px'} fontWeight="medium">
          {props.item.name}
        </Text>
      </Center>
      <Box
        position={'absolute'}
        top={'-10px'}
        right={'-10px'}
        onClick={() =>
          props.onPressInfo(
            props.item.id,
            props.item.name,
            props.item.description_image,
            props.item.description_ratio,
            props.item.description
          )
        }>
        <Image src="/assets/images/icn_question.svg" />
      </Box>
    </Box>
  );
}
export default SubMenuItem;
